import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import STreeList from "@/components/Tree/STreeList";
import { userTree, deleteOrganizationById } from "@/service/structure";
import AddManage from "@/views/MGT/Organizational/modal/AddManage";
import { userTreeChange } from "@/libs/common";
import { mapState } from "vuex";
export default {
  name: "TreeMune",
  components: {
    STreeList,
    AddManage
  },
  props: {
    org: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      data: [],
      more: [{
        name: $t("enc3e35", "添加子部门"),
        code: "addchildrenManage",
        callBack: this.openModal
      }, {
        name: $t("ai67664", "修改名称"),
        code: "editName",
        callBack: this.openModal
      }, {
        name: $t("eslg2", "删除"),
        code: "delete",
        callBack: this.openModal,
        confirm: true,
        confirmTitle: $t("frotru4", "确认删除") + "?"
      }],
      initCheckObj: {},
      routePageCheckObj: {},
      initDG: false,
      addManage: {
        visible: false,
        item: null
      }
    };
  },
  computed: {
    ...mapState(["user"]),
    isAdmin() {
      return this.user.userInfo.isAdmin === "T";
    }
  },
  methods: {
    /*
     ** 添加more内容,并处理为可响应变量
     */
    addMore(item) {
      if (!item.more) {
        let more = () => {
          if (item.parentId === item.orgId) {
            return [this.more[0]];
          } else {
            return this.more;
          }
        };
        this.$set(item, "more", more());
      }
    },
    /*
     ** 设置基础属性
     */
    initBaseAttr(item) {
      if (!item.expand) {
        item.title = item.name;
        if (item.parentId === item.orgId) {
          this.$set(item, "expand", true);
        } else {
          this.$set(item, "expand", false);
        }
        //如果路由进入
        let targetId = this.$route.query.targetId;
        if (targetId) {
          if (item.orgId === targetId) {
            this.routePageCheckObj = item;
          }
        }
      }
    },
    /*
     ** 递归遍历
     */
    DG(id) {
      let data = this.data;
      let change = arr => {
        arr.forEach(v => {
          this.$set(v, "check", false);
          this.initBaseAttr(v);
          this.addMore(v);
          if (id && id === v.orgId) {
            this.initCheckObj = v;
          }
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(data);
      this.data = data;
    },
    /*
     ** 回显
     */
    autoArrive(targetId) {
      let data = this.data;
      let parentId = "";
      let getParentId = arr => {
        arr.map(v => {
          if (v.orgId === targetId) {
            parentId = v.parentId;
          }
          if (!parentId) {
            let children = v.children;
            if (children && children.length > 0) {
              getParentId(children);
            }
          }
        });
      };
      getParentId(data);
      let change = arr => {
        arr.forEach(v => {
          if (parentId) {
            if (v.orgId !== parentId) {
              let children = v.children;
              if (children && children.length > 0) {
                change(children);
              }
            } else {
              if (v.parentId) {
                parentId = v.parentId;
                v.expand = true;
                change(data);
              } else {
                parentId = "";
              }
            }
          }
        });
      };
      change(data);
    },
    /*
     ** 设置选择项
     */
    onSelect(item) {
      this.DG();
      item.check = true;
      let org = {
        ...item,
        actionValue: "1"
      };
      this.$emit("changeOrg", org);
    },
    /*
     ** 更多回调函数
     */
    openModal(key, item) {
      switch (key) {
        case "addManage":
          this.addManage.item = null;
          this.addManage.visible = true;
          break;
        case "addchildrenManage":
          this.addManage.item = {
            ...item,
            ...{
              type: "add"
            }
          };
          this.addManage.visible = true;
          break;
        case "editName":
          this.addManage.item = {
            ...item,
            ...{
              type: "edit"
            }
          };
          this.addManage.visible = true;
          break;
        case "role":
          console.log("role");
          break;
        case "resources":
          console.log("resources");
          break;
        case "delete":
          this.deleteTree(item);
          break;
        default:
          break;
      }
    },
    /*
     ** 树型数据更新
     */
    updateTree() {
      if (this.data.length > 0) {
        this.initCheckObj = this.data[0];
        this.onSelect(this.initCheckObj);
      }
    },
    /*
     ** 不折叠更新
     */
    userByOrgUpdate(id) {
      this.DG(id);
      this.onSelect(this.initCheckObj);
      this.initCheckObj.expand = true;
      this.autoArrive(this.initCheckObj.orgId);
    },
    /*
     ** 获取用户所在组织树
     */
    async getTree(id) {
      this.$emit("clear");
      let res = await userTree();
      if (res.data && res.data.result === 0) {
        this.data = userTreeChange(res.data.retVal);
        if (id) {
          this.userByOrgUpdate(id);
        }
      }
    },
    async update() {
      await this.getTree();
      this.updateTree();
    },
    /*
     ** 删除部门
     */
    async deleteTree(item) {
      if (item.children && item.children.length > 0) {
        this.$Message.error($t("wiwkqt7", "请先删除子部门"));
        return;
      }
      const params = {
        id: item.id,
        orgId: item.orgId
      };
      let res = await deleteOrganizationById(params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("azeh8z4", "删除成功"));
        this.getTree(item.parentId);
      }
    }
  },
  async mounted() {
    await this.getTree();
    if (this.$route.query.targetId) {
      //如果路由进入
      this.$nextTick(() => {
        this.DG();
        this.onSelect(this.routePageCheckObj);
        this.autoArrive(this.$route.query.targetId);
      });
    } else {
      this.updateTree();
    }
  }
};